import { createStore } from 'effector'

import { GetInfoRes } from '../../services/api/Whatsapp'

import { getInfoFx } from './event'

export const $info = createStore<Partial<GetInfoRes>>({})
  .on(getInfoFx.done, (_, { result }) => result.data.data)
